export const NAME = "projects/detail" as const;
